import React, { useEffect, useState } from "react";
import EditAvatarPopup from './EditAvatarPopup';
import { FileUrlsProvider } from '../contexts/FileUrlsContext';
import { DataGrid } from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import FileUploadPopup from './FileUploadPopup';
import UploadIcon from '@mui/icons-material/CloudUpload';
import AddBulkPopup from './AddBulkPopup';
import SaveIcon from '@mui/icons-material/Save';
import { useSelector, useDispatch } from "react-redux";
import { setCards } from "../features/cards/cardsSlice";
import Card from "../components/Card";
import { api } from "../utils/api";

//NOTE: здесь в пропсах передаются функции и состояния, которые используются только в данном компоненте. Не лучше ли перенести эти сущности в сам компонент, а не передавать их извне? Тогда будет проще поддерживать приложение. Например, данный компонент нужно будет удалить. В связи с этим возникнет проблема с неиспользуемым кодом в компоненте App (ведь функции больше не передаются в удаленный компонент). Придется проводить чистку еще и в App. Или, если понадобится добавить/отредактировать логику функции/состояния, то опять же придется в двух местах редактировать и следить, чтобы не было ошибок.

//NOTE: а еще лучше для стейт-менеджмента использовать redux, тогда не понадобится пробрасывать функции и состояния из компонента в компонент

import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import Divider from '@mui/material/Divider';
import * as authentication from '../utils/auth';
function Main(props) {
  // Получаем пользователя из Redux
  const currentUser = useSelector((state) => state.user.currentUser);
  const cards = useSelector((state) => state.cards.cards);
  const editButtonsVisible = useSelector((state) => state.ui.editButtonsVisible);
  const [users, setUsers] = useState([]);
  const [newEmail, setNewEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState('');
  // Viewing another user's cards (admin)
  const [viewingUser, setViewingUser] = useState(null);
  const [viewingCards, setViewingCards] = useState(null);
  const [loadingViewing, setLoadingViewing] = useState(false);
  // Состояния для открытия попапа загрузки и хранения выбранного пользователя
  const [uploadPopupOpen, setUploadPopupOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [bulkUserId, setBulkUserId] = useState(null);
  const [bulkPopupOpen, setBulkPopupOpen] = useState(false);
  const [editAvatarPopupOpen, setEditAvatarPopupOpen] = useState(false);
  // Dropped carts toggle / data
  const [showDropped, setShowDropped] = useState(false);
  const [droppedUserIds, setDroppedUserIds] = useState([]);
  const [loadingDropped, setLoadingDropped] = useState(false);

  const dispatch = useDispatch();

  // Avatar update handler
  const handleAvatarChange = async (data) => {
    try {
      if (currentUser.isAdmin && viewingUser && viewingUser._id !== currentUser._id) {
        if (api.updateAvatarById) {
          const updatedUser = await api.updateAvatarById(viewingUser._id, data);
          setViewingUser(prev => ({ ...prev, ...updatedUser }));
          setUsers(users.map(u => u._id === updatedUser._id ? { ...u, ...updatedUser } : u));
        }
      } else {
        // Update own avatar
        const updatedUser = await api.setUserAvatar(data);
        // Update current user in redux for immediate UI update
        dispatch(require('../features/user/userSlice').setCurrentUser(updatedUser));
      }
      setEditAvatarPopupOpen(false);
    } catch (e) {
      console.error('Ошибка обновления аватара', e);
    }
  };
  // Handle profile update when about field is edited
  const handleProfileUpdate = async (params, event) => {
    try {
      let updatedUser;
      if (params.field === 'familyId') {
        updatedUser = await api.updateFamilyIdById(params.id, event.target.value);
      } else if (params.field === 'isPrinting') {
        // Toggle printing state on the server
        updatedUser = await api.updatePrintingById(params.id);
      } else if (params.field === 'isClosed') {
        // Toggle closed state on the server
        updatedUser = await api.updateClosedById(params.id);
      } else if (params.field === 'hasPaid') {
        // Numeric payment field - validate non-negative number
        const raw = event && event.target ? event.target.value : params.value;
        const value = raw === '' || raw === null || typeof raw === 'undefined' ? 0 : Number(raw);
        if (isNaN(value) || value < 0) {
          alert('Payment must be a non-negative number');
          return false;
        }
        updatedUser = await api.updatePaidById(params.id, value);
      } else if (params.field === 'password') {
        const newPassword = event.target.value;
        if (!newPassword || newPassword.length < 8 || /\s/.test(newPassword)) {
          alert('PIN must be at least 8 characters, not empty, and contain no spaces.');
          return false;
        }
        updatedUser = await api.updateUserPassword(params.id, newPassword);
      } else {
        updatedUser = await api.updateProfileById(params.id, {
          name: params.field === 'name' ? event.target.value : params.row.name,
          about: params.field === 'about' ? event.target.value : params.row.about,
        });
      }
      setUsers(users.map(user =>
        user._id === updatedUser._id ? { ...user, ...updatedUser } : user
      ));
      if (viewingUser && viewingUser._id === updatedUser._id) {
        setViewingUser(prev => ({ ...prev, ...updatedUser }));
        setLoadingViewing(true);
        try {
          const userCards = await api.getCardsByUserId(updatedUser._id);
          setViewingCards(userCards || []);
        } catch (e) {
          // Optionally handle error
        } finally {
          setLoadingViewing(false);
        }
      }
    } catch (error) {
      console.error('Failed to update profile:', error);
      return false;
    }
  };

  // helper: view cards of any user (admin)
  const handleViewUserCards = async (userId) => {
    setLoadingViewing(true);
    try {
      // Get user info
      const userData = await api.getUserById(userId);
      setViewingUser(userData);

      // Always fetch cards for this user
      const userCards = await api.getCardsByUserId(userId);
      setViewingCards(userCards || []);
    } catch (e) {
      console.error(e);
      alert('Ошибка получения карточек пользователя');
    } finally {
      setLoadingViewing(false);
    }
  };


  useEffect(() => {
    if (currentUser && currentUser.isYearbookTeamMember === true) {
      api.getYearbookCards()
        .then(cards => {
          dispatch(setCards(cards));
        })
        .catch(() => {
          dispatch(setCards([]));
        });
    } else if (currentUser && currentUser.isAdmin === true) {
      api.getAllUsers().then(setUsers).catch(() => setUsers([]));
    } else if (currentUser && !currentUser.isAdmin) {
      // For standard user, check familyId
      if (currentUser.familyId) {
        api.getCardsByFamilyId(currentUser.familyId)
          .then(cards => {
            dispatch(setCards(cards)); // This will update the cards array for all family members
          })
          .catch(() => {
            dispatch(setCards([]));
          });
      } else {
        // Default: fetch cards by owner (current logic)
        // If using Redux, this is probably already handled elsewhere
      }
    }
  }, [currentUser, dispatch]);



  if (currentUser.isAdmin) {
    // Формируем колонки для таблицы
    const handleDeleteUser = (userId) => {
      if (window.confirm('Удалить пользователя?')) {
        api.deleteUserById(userId)
          .then(() => setUsers((prev) => prev.filter((u) => u._id !== userId)))
          .catch(() => alert('Ошибка удаления пользователя'));
      }
    };


    const handleCreateUser = async () => {
      setError('');
      setCreating(true);
      try {
        await authentication.register(newEmail, newPassword);
        setNewEmail('');
        setNewPassword('');
        // Обновить список пользователей
        const updated = await api.getAllUsers();
        setUsers(updated);
      } catch (e) {
        setError('Ошибка создания пользователя');
      } finally {
        setCreating(false);
      }
    };


    // Открытие AddBulkPopup для конкретного пользователя
    const handleBulkAddUser = (userId) => {
      setBulkUserId(userId);
      setBulkPopupOpen(true);
    };

    const handleToggleDropped = async () => {
      // Toggle ON: fetch dropped carts user list once. Toggle OFF: clear highlights.
      if (!showDropped) {
        setLoadingDropped(true);
        try {
          const result = await api.getDroppedCarts();
          const ids = Array.isArray(result) ? result.map(u => u._id) : [];
          setDroppedUserIds(ids);
          setShowDropped(true);
        } catch (err) {
          console.error('Failed to fetch dropped carts:', err);
          alert('Failed to fetch dropped carts: ' + err);
          setDroppedUserIds([]);
          setShowDropped(false);
        } finally {
          setLoadingDropped(false);
        }
      } else {
        // Turn off
        setShowDropped(false);
        setDroppedUserIds([]);
      }
    };

    const columns = [
      { field: 'name', headerName: 'Name', flex: 1, sortable: true, editable: true },
      {
        field: 'email',
        headerName: 'Email',
        flex: 1,
        sortable: true,
        renderCell: (params) => (
          <button
            type="button"
            style={{ cursor: 'pointer', color: '#1976d2', textDecoration: 'underline', background: 'transparent', border: 'none', padding: 0 }}
            onClick={() => handleViewUserCards(params.row._id)}
          >
            {params.value}
          </button>
        ),
      },
      {
        field: 'password',
        headerName: 'Pin',
        flex: 0.5,
        sortable: false,
        editable: true,
      },
      {
        field: 'about',
        headerName: 'About',
        flex: 0.5,
        sortable: true,
        editable: true,
      },
      { field: 'familyId', headerName: 'Family ID', flex: 0.5, sortable: true, editable: true },
      //{ field: 'isAdmin', headerName: 'Admin', flex: 0.5, type: 'boolean', sortable: true },
      {
        field: 'avatar',
        headerName: 'Avatar',
        flex: 0.5,
        sortable: false,
        align: 'center',
        headerAlign: 'center',
        renderCell: (params) => (
          <img
            src={params.value}
            alt="avatar"
            style={{
              width: 48,
              height: 48,
              objectFit: 'cover',
              objectPosition: 'top',
              borderRadius: '50%',
            }}
          />
        ),
      },
      {
        field: 'isNotified',
        headerName: 'Notified',
        flex: 0.5,
        type: 'boolean',
        sortable: true,
        renderCell: (params) => (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Button
              variant={params.value ? "contained" : "outlined"}
              color={params.value ? undefined : "primary"}
              size="small"
              disabled={params.value}
              style={params.value ? { backgroundColor: '#b2fab4', color: '#222', cursor: 'not-allowed' } : {}}
              onClick={params.value ? undefined : async (e) => {
                e.stopPropagation(); // Prevent row selection
                try {
                  // Send email and set notified status
                  await api.sendEmail({
                    to: params.row.email,
                    subject: 'Your Photos are Ready!',
                    html: `<p>Hello ${params.row.name},<br/>
                    You can now log in and order your photos here:<br/>
                      <a href="https://myphotodelight.ru/sign-in?email=${params.row.email}&password=${params.row.password}" target="_blank" rel="noopener noreferrer">https://myphotodelight.ru/sign-in?email=${params.row.email}&password=${params.row.password}</a><br/><br/>
                      Should you have any questions, feel free to reply to this email or WhatsApp/Telegram at +79858357632.<br/><br/>
                      Best regards,<br/>
                      Alexander Abilov<br/>
                      Hinkson Christian Academy Photography
                    </p>`
                  });
                  await api.setUserNotified(params.row._id, true);
                  setUsers(users => users.map(u => u._id === params.row._id ? { ...u, isNotified: true } : u));
                  alert('Email sent!');
                } catch (err) {
                  alert('Failed to send email: ' + err);
                }
              }}
            >
              {params.value ? "NOTIFIED" : "Notify"}
            </Button>
          </div>
        ),
      },
      { field: 'isPrinting', headerName: 'Printing', flex: 0.5, type: 'boolean', sortable: true, editable: true },
      {
        field: 'hasPaid',
        headerName: 'Paid (₽)',
        flex: 0.5,
        type: 'number',
        sortable: true,
        editable: true,
        renderCell: (params) => (
          <div style={{ textAlign: 'center', width: '100%' }}>
            {typeof params.value !== 'undefined' && params.value !== null ? params.value : 0}
          </div>
        ),
      },
      { field: 'isClosed', headerName: 'Closed', flex: 0.5, type: 'boolean', sortable: true, editable: true },
      {
        field: 'actions',
        headerName: 'Delete',
        flex: 0.4,
        sortable: false,
        filterable: false,
        align: 'center',
        headerAlign: 'center',
        renderCell: (params) => (
          <IconButton
            aria-label="delete"
            color="error"
            size="small"
            onClick={(e) => {
              e.stopPropagation(); // prevent row selection
              handleDeleteUser(params.row._id);
            }}
          >
            <DeleteIcon />
          </IconButton>
        ),
      },
    ];
    // DataGrid требует поле id
    const rows = Array.isArray(users)
      ? users.map((user) => ({ ...user, id: user._id, _id: user._id }))
      : [];
    return (
      <main className="main">
        <h2>Админ-панель</h2>
        <div style={{ marginTop: 200 }}>
          <div style={{ display: 'flex', gap: 16, marginBottom: 24, alignItems: 'center' }}>
            <TextField
              label="Email"
              value={newEmail}
              onChange={e => setNewEmail(e.target.value)}
              size="small"
              type="email"
              autoComplete="off"
              InputProps={{ style: { color: '#fff' } }}
              InputLabelProps={{ style: { color: '#fff' } }}
              sx={{
                '& .MuiInputBase-input::placeholder': { color: '#fff', opacity: 1 },
                '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': { borderColor: '#fff' },
                '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#fff' },
                '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#fff' },
              }}
              placeholder="Email"
            />
            <TextField
              label="Password"
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
              size="small"
              type="password"
              autoComplete="new-password"
              InputProps={{ style: { color: '#fff' } }}
              InputLabelProps={{ style: { color: '#fff' } }}
              sx={{
                '& .MuiInputBase-input::placeholder': { color: '#fff', opacity: 1 },
                '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': { borderColor: '#fff' },
                '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#fff' },
                '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#fff' },
              }}
              placeholder="Password"
            />
            <Button
              variant="contained"
              sx={{ background: '#fff', color: '#222', fontWeight: 700, '&:hover': { background: '#eee', color: '#222' } }}
              onClick={handleCreateUser}
              disabled={creating || !newEmail || !newPassword}
            >
              Create User
            </Button>
            <Button
              variant={showDropped ? "contained" : "outlined"}
              color={showDropped ? "warning" : "primary"}
              sx={{ fontWeight: 700 }}
              onClick={handleToggleDropped}
              disabled={loadingDropped}
            >
              {showDropped ? 'HIDE DROPPED CARTS' : 'SHOW DROPPED CARTS'}
            </Button>
            {error && <span style={{ color: 'red', marginLeft: 8 }}>{error}</span>}
          </div>
          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10, 25, 50]}
            disableSelectionOnClick
            autoHeight={false}
            sx={{ fontSize: 16 }}
            getRowClassName={(params) => (droppedUserIds && droppedUserIds.includes(params.row._id) ? 'highlight-dropped' : '')}
            onCellEditStop={handleProfileUpdate}
          />
          {/* Permanent Drawer for viewing user's cards */}
          <Drawer
            variant="persistent"
            anchor="right"
            PaperProps={{
              sx: { width: 340, boxSizing: 'border-box', background: '#fafbfc', borderLeft: '1px solid #eee', padding: 0, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }
            }}
            open={!!viewingUser}
          >
            <div style={{ flex: 1, overflow: 'auto' }}>
              <div style={{ padding: 20, minHeight: 120 }}>
                {viewingUser && (
                  <>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                      <img
                        src={viewingUser.avatar}
                        alt={viewingUser.name}
                        style={{ width: 48, height: 48, objectFit: 'cover', objectPosition: 'top', borderRadius: '50%', cursor: 'pointer' }}
                        onClick={() => setEditAvatarPopupOpen(true)}
                      />
                      <div>
                        <h3 style={{ margin: 0, fontSize: 18 }}>{viewingUser.name}</h3>
                        <div style={{ fontSize: 13, color: '#888' }}>{viewingUser.email}</div>
                        <div style={{ fontSize: 13, color: '#888' }}>{viewingUser.about}</div>
                        <Button
                          variant="outlined"
                          color="warning"
                          size="small"
                          style={{ marginTop: 8 }}
                          onClick={async () => {
                            try {
                              await api.setUserNotified(viewingUser._id, false); // send isNotified: false
                              setUsers(users => users.map(u => u._id === viewingUser._id ? { ...u, isNotified: false } : u));
                              setViewingUser({ ...viewingUser, isNotified: false });
                              alert('Notify status reset!');
                            } catch (err) {
                              alert('Failed to reset notify status: ' + err);
                            }
                          }}
                        >RESET NOTIFY STATUS</Button>
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
                      <IconButton
                        aria-label="upload"
                        color="primary"
                        onClick={() => {
                          setSelectedUserId(viewingUser._id);
                          setUploadPopupOpen(true);
                        }}
                      >
                        <UploadIcon />
                      </IconButton>
                      <IconButton
                        aria-label="save"
                        color="success"
                        onClick={() => handleBulkAddUser(viewingUser._id)}
                      >
                        <SaveIcon />
                      </IconButton>
                    </div>
                  </>
                )}
              </div>
              <Divider />
              <div style={{ padding: 16, overflowY: 'auto', maxHeight: 'calc(100vh - 220px)' }}>
                {loadingViewing && viewingUser && <div>Loading cards...</div>}
                {!loadingViewing && viewingUser && (!viewingCards || viewingCards.length === 0) && <div>No cards for this user.</div>}
                {!loadingViewing && viewingUser && viewingCards && (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, justifyContent: 'center' }}>
                    {viewingCards.map((card, index) => (
                      <div key={card._id} style={{ width: 140, textAlign: 'center', position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <button
                          type="button"
                          className="element__avatar-btn"
                          onClick={() => {
                            handleAvatarChange({ avatar: card.link });
                          }}
                        />
                        <button
                          type="button"
                          className="element__trash-btn"
                          onClick={async () => {
                            if (window.confirm('Удалить эту карточку?')) {
                              try {
                                await api.deleteCard(card._id);
                                setViewingCards((await api.getCardsByUserId(viewingUser._id)) || []);
                              } catch (e) {
                                alert('Ошибка удаления карточки');
                              }
                            }
                          }}
                        />
                        <img
                          src={card.link}
                          alt={card.name || `card-${index}`}
                          style={{ width: 130, height: 100, objectFit: 'cover', borderRadius: 6, boxShadow: '0 2px 8px #0001', marginTop: 4 }}
                        />
                        <div style={{ marginTop: 4, fontSize: 13, color: '#555', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{card.name}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div style={{ padding: 16, borderTop: '1px solid #eee' }}>
              <Button fullWidth variant="contained" color="primary" onClick={() => { setViewingUser(null); setViewingCards(null); }}>CLOSE</Button>
            </div>
          </Drawer>
          <FileUploadPopup
            isOpen={uploadPopupOpen}
            onClose={() => setUploadPopupOpen(false)}
            userId={selectedUserId}
            onOpenBulk={(userId) => {
              setBulkUserId(userId);
              setBulkPopupOpen(true);
              setUploadPopupOpen(false);
            }}
          />
          <EditAvatarPopup
            isOpen={editAvatarPopupOpen}
            onClose={() => setEditAvatarPopupOpen(false)}
            onAvatarChange={handleAvatarChange}
          />
          <AddBulkPopup
            isOpen={bulkPopupOpen}
            onClose={() => {
              setBulkPopupOpen(false);
              setBulkUserId(null);
            }}
            userId={bulkUserId}
            onAdd={async (...args) => {
              if (props.onAdd) await props.onAdd(...args);
              // Refresh cards for the user in the drawer
              if (viewingUser && viewingUser._id) {
                setLoadingViewing(true);
                try {
                  const userCards = await api.getCardsByUserId(viewingUser._id);
                  setViewingCards(userCards || []);
                } catch (e) {
                  // Optionally handle error
                } finally {
                  setLoadingViewing(false);
                }
              }
            }}
          />
        </div>
      </main>
    );
  }

  // ...существующий пользовательский интерфейс...
  return (
    <main className="main">
      <section className="profile">
        <div onClick={props.onAvatarEdit} className="profile__avatar">
          <img
            src={currentUser.avatar}
            className="profile__image"
            alt={currentUser.name}
          />
        </div>
        <div className="gradient"></div>
        <div className="profile__info">
          <div className="profile__wrapper">
            <h1 className="profile__title">{currentUser.name}</h1>
            <button
              onClick={props.onProfileEdit}
              type="button"
              className="profile__edit-btn"
            />
          </div>
          <h2 className="profile__occupation">{currentUser.about}</h2>
        </div>

        <div className="profile__buttons">
          {!editButtonsVisible && (
            <>
              <button
                onClick={props.onInstructionsClick}
                type="button"
                className="btn-instructions"
              >
                <span>instructions</span>
              </button>
            </>
          )}
          {editButtonsVisible && (
            <>
              <button
                onClick={props.onFileUpload}
                type="button"
                className="profile__upload-btn"
              ></button>
              <button
                onClick={props.onBulk}
                type="button"
                className="profile__add-btn"
              ></button>
            </>
          )}
        </div>
      </section>
      <section className="elements card--animated">
        {cards.map((card, index) => (
          <div
            key={card._id}
            className="card-animated"
            style={{ animationDelay: `${index * 100}ms`, position: 'relative' }}
          >
            <Card
              card={card}
              onImageClick={props.onImageClick}
              onHandleConfirmDeleteCard={props.onHandleConfirmDeleteCard}
              onHandleAvatarChange={props.onHandleAvatarChange}
              onSmallPrintClickUp={props.onSmallPrintClickUp}
              onSmallPrintClickDown={props.onSmallPrintClickDown}
              onBigPrintClickUp={props.onBigPrintClickUp}
              onBigPrintClickDown={props.onBigPrintClickDown}
              onDownloadOption={props.onDownloadOption}
              onYearbookOption={props.onYearbookOption}
            />
          </div>
        ))}
      </section>
    </main>
  );
}

export default function MainWithFileUrlsProvider(props) {
  return (
    <FileUrlsProvider>
      <Main {...props} />
    </FileUrlsProvider>
  );
}
